import {
  breakpoints,
  CascadiaBreakpoint,
  CascadiaSpacing,
  spacing,
} from "@certn/cascadia-tokens";

export function space(val: CascadiaSpacing) {
  return spacing[val];
}

export function rem(val: CascadiaSpacing | { rem: number; px: number }) {
  if (typeof val === "string") {
    val = space(val);
  }

  return `${val.rem}rem`;
}

export function px(
  val?: CascadiaSpacing | { rem: number; px: number },
  defaultValue = undefined
) {
  if (typeof val === "string") {
    val = space(val);
  }

  if (!val) {
    return defaultValue;
  }

  return val.px;
}

export function bp(breakpoint: CascadiaBreakpoint) {
  return breakpoints[breakpoint].maxWidth;
}

export function cssToken(val?: string | false) {
  return val ? `var(--${val})` : undefined;
}
